import { render } from "./gsrbr0601.vue?vue&type=template&id=0a0d6dd6&scoped=true"
import script from "./gsrbr0601.vue?vue&type=script&lang=js"
export * from "./gsrbr0601.vue?vue&type=script&lang=js"

import "./gsrbr0601.vue?vue&type=style&index=0&id=0a0d6dd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0d6dd6"]])

export default __exports__